import React from "react";
import MoonMark from "@/components/MoonMark";

export const MoonDivider = ({ label }) => (
  <div className="flex items-center justify-center gap-4 my-2" aria-hidden={!label}>
    <span className="h-px w-16 sm:w-28 bg-gradient-to-r from-transparent to-gold/60" />
    <MoonMark className="h-8 w-auto" />
    {label ? (
      <span className="font-body uppercase tracking-[0.35em] text-xs text-champagne/90">{label}</span>
    ) : null}
    <span className="h-px w-16 sm:w-28 bg-gradient-to-l from-transparent to-gold/60" />
  </div>
);

export default MoonDivider;
